import { render, staticRenderFns } from "./MinibusRequest.vue?vue&type=template&id=75dc83fc&scoped=true&"
import script from "./MinibusRequest.vue?vue&type=script&lang=js&"
export * from "./MinibusRequest.vue?vue&type=script&lang=js&"
import style0 from "./MinibusRequest.vue?vue&type=style&index=0&id=75dc83fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc83fc",
  null
  
)

export default component.exports